import { WithClassName } from "@/types/base";
import {
  chakra,
  ChakraProps,
  Flex,
  Icon,
  IconProps,
  Tooltip,
  TooltipProps,
} from "@chakra-ui/react";
import { ReactNode } from "react";

export const Check = (props: ChakraProps) => (
  <Icon w="16px" width="17" height="16" viewBox="0 0 17 16" fill="none" stroke="#36C19E" {...props}>
    <g clipPath="url(#clip0_2773_8488)">
      <path
        d="M6 8.33398L8 10.334L11.3333 6.33398"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M8.66667 14.6673C12.3486 14.6673 15.3333 11.6825 15.3333 8.00065C15.3333 4.31875 12.3486 1.33398 8.66667 1.33398C4.98477 1.33398 2 4.31875 2 8.00065C2 11.6825 4.98477 14.6673 8.66667 14.6673Z"
        strokeWidth="1.5"
        fill="none"
      />
    </g>
    <defs>
      <clipPath id="clip0_2773_8488">
        <rect width="16" height="16" fill="white" transform="translate(0.666016)" />
      </clipPath>
    </defs>
  </Icon>
);
export const Close = (props: ChakraProps) => (
  <Icon w="16px" width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#F76560" {...props}>
    <g clipPath="url(#clip0_2773_8484)">
      <path
        d="M8.00065 14.6673C11.6827 14.6673 14.6673 11.6827 14.6673 8.00065C14.6673 4.31865 11.6827 1.33398 8.00065 1.33398C4.31865 1.33398 1.33398 4.31865 1.33398 8.00065C1.33398 11.6827 4.31865 14.6673 8.00065 14.6673Z"
        strokeWidth="1.5"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M9.88657 6.11328L6.11523 9.88461M6.11523 6.11328L9.88657 9.88461"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </g>
    <defs>
      <clipPath id="clip0_2773_8484">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);

export const Info = (props: IconProps) => (
  <Icon width="12" height="12" viewBox="0 0 12 12" fill="#999999" {...props}>
    <g clipPath="url(#clip0_2773_7878)">
      <path
        d="M6 11.25C4.60761 11.25 3.27226 10.6969 2.28769 9.71231C1.30312 8.72774 0.75 7.39239 0.75 6C0.75 4.60761 1.30312 3.27226 2.28769 2.28769C3.27226 1.30312 4.60761 0.75 6 0.75C7.39239 0.75 8.72774 1.30312 9.71231 2.28769C10.6969 3.27226 11.25 4.60761 11.25 6C11.25 7.39239 10.6969 8.72774 9.71231 9.71231C8.72774 10.6969 7.39239 11.25 6 11.25ZM6 12C7.5913 12 9.11742 11.3679 10.2426 10.2426C11.3679 9.11742 12 7.5913 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 0 6 0C4.4087 0 2.88258 0.632141 1.75736 1.75736C0.632141 2.88258 0 4.4087 0 6C0 7.5913 0.632141 9.11742 1.75736 10.2426C2.88258 11.3679 4.4087 12 6 12Z"
        stroke="none"
      />
      <path
        d="M6.69749 4.941L4.97999 5.15625L4.91849 5.44125L5.25599 5.5035C5.47649 5.556 5.51999 5.6355 5.47199 5.85525L4.91849 8.45625C4.77299 9.129 4.99724 9.4455 5.52449 9.4455C5.93324 9.4455 6.40799 9.2565 6.62324 8.997L6.68924 8.685C6.53924 8.817 6.32024 8.8695 6.17474 8.8695C5.96849 8.8695 5.89349 8.72475 5.94674 8.46975L6.69749 4.941ZM6.74999 3.375C6.74999 3.57391 6.67098 3.76468 6.53032 3.90533C6.38967 4.04598 6.19891 4.125 5.99999 4.125C5.80108 4.125 5.61032 4.04598 5.46966 3.90533C5.32901 3.76468 5.24999 3.57391 5.24999 3.375C5.24999 3.17609 5.32901 2.98532 5.46966 2.84467C5.61032 2.70402 5.80108 2.625 5.99999 2.625C6.19891 2.625 6.38967 2.70402 6.53032 2.84467C6.67098 2.98532 6.74999 3.17609 6.74999 3.375Z"
        stroke="none"
      />
    </g>
    <defs>
      <clipPath id="clip0_2773_7878">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);

type TooltipInfoProps = {
  title: ReactNode;
  info: ReactNode;
  tooltipProps?: Partial<TooltipProps>;
  onIconClick?: React.MouseEventHandler<SVGElement>;
};
export const TooltipInfo = chakra((props: WithClassName<TooltipInfoProps>) => {
  const { title, info, className, tooltipProps, onIconClick } = props;
  return (
    <Tooltip
      className={className}
      label={info}
      placement="right-start"
      hasArrow
      bg="#6a6a6a"
      p="8px 12px"
      maxW="220px"
      {...tooltipProps}
    >
      <Flex align="center">
        {title}
        <Info boxSize="12px" ml="4px" onClick={onIconClick} />
      </Flex>
    </Tooltip>
  );
});

export const More = (props: ChakraProps) => {
  return (
    <Icon width="24" height="24" viewBox="0 0 24 24" fill="#8C8C8C" stroke="none" {...props}>
      <rect width="24" height="24" rx="12" />
      <circle cx="11.9998" cy="7.2" r="1.2" fill="#242425" stroke="none" />
      <circle cx="11.9998" cy="12.0008" r="1.2" fill="#242425" stroke="none" />
      <circle cx="11.9998" cy="16.8016" r="1.2" fill="#242425" stroke="none" />
    </Icon>
  );
};

export const Consult = (props: ChakraProps) => {
  return (
    <Icon width="20" height="19" viewBox="0 0 20 19" fill="none" stroke="white" {...props}>
      <path
        d="M16.667 8.16667C16.667 6.39856 15.9646 4.70286 14.7144 3.45262C13.4641 2.20238 11.7684 1.5 10.0003 1.5C8.23222 1.5 6.53652 2.20238 5.28628 3.45262C4.03604 4.70286 3.33366 6.39856 3.33366 8.16667M16.667 14V14.4167C16.667 14.8587 16.4914 15.2826 16.1788 15.5952C15.8663 15.9077 15.4424 16.0833 15.0003 16.0833H12.0837M1.66699 11.865V10.3017C1.66705 9.93001 1.79133 9.56903 2.02008 9.27611C2.24883 8.98319 2.56893 8.77513 2.92949 8.685L4.37949 8.32167C4.45317 8.30332 4.53006 8.30199 4.60433 8.31778C4.6786 8.33358 4.7483 8.36608 4.80814 8.41283C4.86797 8.45957 4.91638 8.51933 4.94968 8.58757C4.98298 8.65581 5.0003 8.73074 5.00033 8.80667V13.3592C5.00046 13.4353 4.98322 13.5104 4.94993 13.5788C4.91663 13.6472 4.86816 13.7071 4.80821 13.754C4.74826 13.8008 4.6784 13.8334 4.60396 13.8492C4.52952 13.8649 4.45246 13.8635 4.37866 13.845L2.92866 13.4825C2.56825 13.3922 2.24834 13.1841 2.01975 12.8912C1.79116 12.5983 1.667 12.2365 1.66699 11.865ZM18.3337 11.865V10.3017C18.3336 9.93001 18.2093 9.56903 17.9806 9.27611C17.7518 8.98319 17.4317 8.77513 17.0712 8.685L15.6212 8.32167C15.5475 8.30332 15.4706 8.30199 15.3963 8.31778C15.322 8.33358 15.2523 8.36608 15.1925 8.41283C15.1327 8.45957 15.0843 8.51933 15.051 8.58757C15.0177 8.65581 15.0004 8.73074 15.0003 8.80667V13.3592C15.0002 13.4352 15.0175 13.5102 15.0507 13.5785C15.0839 13.6469 15.1323 13.7067 15.1922 13.7536C15.252 13.8004 15.3218 13.833 15.3961 13.8488C15.4704 13.8647 15.5474 13.8634 15.6212 13.845L17.0712 13.4825C17.4317 13.3924 17.7518 13.1843 17.9806 12.8914C18.2093 12.5985 18.3336 12.2367 18.3337 11.865ZM11.2503 17.3333H8.75028C8.41876 17.3333 8.10082 17.2016 7.8664 16.9672C7.63198 16.7328 7.50029 16.4149 7.50029 16.0833C7.50029 15.7518 7.63198 15.4339 7.8664 15.1995C8.10082 14.965 8.41876 14.8333 8.75028 14.8333H11.2503C11.5818 14.8333 11.8997 14.965 12.1342 15.1995C12.3686 15.4339 12.5003 15.7518 12.5003 16.0833C12.5003 16.4149 12.3686 16.7328 12.1342 16.9672C11.8997 17.2016 11.5818 17.3333 11.2503 17.3333Z"
        strokeWidth="1.5"
        fill="none"
      />
    </Icon>
  );
};

export const QrCodeIcon = (props: ChakraProps) => (
  <Icon width="1em" height="1em" viewBox="0 0 24 24" fill="#5F5F5F" {...props}>
    <path d="M3 11H11V3H3V11ZM5 5H9V9H5V5ZM3 21H11V13H3V21ZM5 15H9V19H5V15ZM13 3V11H21V3H13ZM19 9H15V5H19V9ZM19 19H21V21H19V19ZM13 13H15V15H13V13ZM15 15H17V17H15V15ZM13 17H15V19H13V17ZM15 19H17V21H15V19ZM17 17H19V19H17V17ZM17 13H19V15H17V13ZM19 15H21V17H19V15Z" />
  </Icon>
);

export const DocIcon = (props: ChakraProps) => (
  <Icon width="21" height="20" viewBox="0 0 21 20" fill="none" stroke="#4E5969" {...props}>
    <path
      d="M11.5 2H12.5L16.5 6V7M11.5 2H4.5V18H16.5V7M11.5 2V7H16.5M7 10H14M7 13H10.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);

export const APIIcon = (props: ChakraProps) => (
  <Icon width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="#4E5969" {...props}>
    <path
      d="M14.5556 4.94444C13 3.38889 10.8611 4.36111 10.2778 4.94444L9.11111 6.11111L13.3889 10.3889L14.5556 9.22222C15.1389 8.63889 16.1111 6.5 14.5556 4.94444ZM14.5556 4.94444L16.5 3M4.44444 15.0556C6 16.6111 8.13889 15.6389 8.72222 15.0556L9.88889 13.8889L5.61111 9.61111L4.44444 10.7778C3.86111 11.3611 2.88889 13.5 4.44444 15.0556ZM4.44444 15.0556L2.5 17M9.11111 13.1111L10.6667 11.5556M6.38889 10.3889L7.94444 8.83333"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const DownCircle = (props: ChakraProps) => (
  <Icon width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="#165DFF" {...props}>
    <path
      d="M7 1.75C4.1005 1.75 1.75 4.1005 1.75 7C1.75 9.8995 4.1005 12.25 7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.1005 9.8995 1.75 7 1.75Z"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.47468 5.98354L7.00018 8.45833L4.52539 5.98354"
      stroke="#165DFF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

//返回顶部
export const ArrowUp = (props: ChakraProps) => (
  <Icon width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="#4E5969" {...props}>
    <path
      d="M3 9L10 2L17 9M10.0008 17V2.49117"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const Planet = (props: ChakraProps) => (
  <Icon width="21" height="20" viewBox="0 0 21 20" fill="none" stroke="#4E5969" {...props}>
    <g clipPath="url(#clip0_3714_10182)">
      <path
        d="M4.81999 11.3167C2.90999 13.0983 1.86499 14.65 2.24332 15.4C2.86416 16.6167 7.06249 15.1842 11.6225 12.2017C16.1808 9.21918 19.3758 5.81502 18.7558 4.59918C18.3692 3.84085 16.3175 4.22918 13.92 5.27002"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3333 10C16.3333 10.7661 16.1824 11.5246 15.8893 12.2323C15.5961 12.9401 15.1664 13.5831 14.6248 14.1248C14.0831 14.6665 13.44 15.0962 12.7323 15.3893C12.0246 15.6825 11.266 15.8334 10.5 15.8334C9.73394 15.8334 8.97539 15.6825 8.26766 15.3893C7.55993 15.0962 6.91687 14.6665 6.37519 14.1248C5.83351 13.5831 5.40383 12.9401 5.11068 12.2323C4.81753 11.5246 4.66665 10.7661 4.66665 10C4.66665 9.23398 4.81753 8.47543 5.11068 7.7677C5.40383 7.05997 5.83351 6.41691 6.37519 5.87523C6.91687 5.33356 7.55993 4.90388 8.26766 4.61072C8.97539 4.31757 9.73394 4.16669 10.5 4.16669C11.266 4.16669 12.0246 4.31757 12.7323 4.61072C13.44 4.90388 14.0831 5.33356 14.6248 5.87523C15.1664 6.41691 15.5961 7.05997 15.8893 7.7677C16.1824 8.47543 16.3333 9.23398 16.3333 10Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </g>
    <defs>
      <clipPath id="clip0_3714_10182">
        <rect width="20" height="20" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </Icon>
);
